const icon = `
<svg version="1.1" id="Layer_2" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 35 35" style="enable-background:new 0 0 35 35;" xml:space="preserve">
<style type="text/css">
	.st0{fill:{{strokeColor}};}
</style>
<path class="st0" d="M13.73,17.37c0,4.07-2.2,6.39-5.19,6.39c-3.06,0-4.99-2.61-4.99-6.18c0-3.73,2.09-6.36,5.15-6.36
	C11.86,11.23,13.73,13.92,13.73,17.37z M5.64,17.55c0,2.47,1.11,4.43,3.01,4.43c1.91,0,2.99-1.98,2.99-4.52
	c0-2.29-1.01-4.45-2.99-4.45C6.68,13.02,5.64,15.05,5.64,17.55z"/>
<path class="st0" d="M23.2,23.21c-0.47,0.27-1.5,0.54-2.8,0.54c-3.44,0-5.53-2.41-5.53-6.1c0-4,2.48-6.41,5.79-6.41
	c1.3,0,2.24,0.31,2.64,0.54l-0.43,1.76c-0.51-0.25-1.22-0.47-2.12-0.47c-2.2,0-3.8,1.55-3.8,4.47c0,2.66,1.4,4.38,3.78,4.38
	c0.8,0,1.64-0.18,2.16-0.45L23.2,23.21z"/>
<path class="st0" d="M24.84,21.16c0.64,0.41,1.61,0.77,2.62,0.77c1.27,0,1.98-0.67,1.98-1.66c0-0.92-0.55-1.46-1.93-2.02
	c-1.79-0.72-2.93-1.78-2.93-3.53c0-1.98,1.48-3.49,3.83-3.49c1.17,0,2.04,0.29,2.61,0.61l-0.48,1.78c-0.39-0.23-1.14-0.58-2.16-0.58
	c-1.25,0-1.8,0.76-1.8,1.46c0,0.94,0.63,1.37,2.07,2c1.88,0.79,2.8,1.85,2.8,3.6c0,1.94-1.32,3.64-4.12,3.64
	c-1.14,0-2.33-0.36-2.93-0.76L24.84,21.16z"/>
</svg>
`

export const OCS = {
  name: 'OCS',
  description: 'The object groups composing the OCS system',
  icon,
  templates: []
}
